function getIndexDeck() {
  const options = document.querySelector(`.product-form__variants`);
  var unit = document.getElementById('swatch-2-metric').checked ?  "Metric" : "Imperial" 
  var variant = document.getElementById("SingleOptionSelector-0").value;
  var sidelaps = document.getElementById("swatch-1-screwed-cladding").checked ? "Screwed (cladding)" : "Button punch";
  var fullProductTitle = "";
  fullProductTitle  = fullProductTitle.concat(variant, " \/ " ,sidelaps, " \/ " , unit)
  var currentVariantID;
  
  for(i = 0; i < options.length; i++) {
       if (options[i].getAttribute("title-value") == fullProductTitle) {
           currentVariantID = options[i].index;
       }
     };

  return currentVariantID;
}

function getPriceDeck() {
  return deckMap.get(title).get(description).get("price");
}

function getWeightDeck() {
  return deckMap.get(title).get(description).get("weight");
}

function getVariantIdDeck() {
  return document.querySelector(`.product-form__variants`)[getIndexDeck()].value;
}

if (typeof isDeck === undefined) {
  var isDeck = false;
}

// DECK function
// Return whether metric input entered is valid or not.
// Uses the bounds determined in the field's min and max attributes.
function validateMetric() {
  let input = document.getElementById('length_input_metric');
  let error = document.getElementById('length_error');
  let v = parseInt(input.value);
  let min = input.getAttribute('min');
  let max = input.getAttribute('max');
  if (v >= min && v <= max) {
    clearError(error);
    return true;
  } else if (!v) {
    displayError(error, productLengthMissingError);
    return false;
  }
  displayError(error, productLengthOutOfBoundsError);
  return false;
}

// DECK function
// Return whether imperial input entered is valid or not.
// Uses the bounds determined in the field's min and max attributes.
function validateImperial() {
  let ft_input = document.getElementById('length_input_fe');
  let in_input = document.getElementById('length_input_in');
  let error = document.getElementById('length_error');
  let v = parseInt(ft_input.value) + (parseInt(in_input.value) / 12);
  let min = ft_input.getAttribute('min');
  let max = ft_input.getAttribute('max');
  if (v >= min && v <= max) {
    clearError(error);
    return true;
  } else if (!v) {
    displayError(error, productLengthMissingError);
    return false;
  }
  displayError(error, productLengthOutOfBoundsError);
  return false;
}

// DECK function
// Return whether quantity entered is valid or not.
// Uses the bounds determined in the field's min and max attributes.
function validateQty() {
  let input = document.getElementById('quantity_input');
  let error = document.getElementById('quantity_error');
  let v = parseInt(input.value);
  let min = input.getAttribute('min');
  if (v >= min) {
    clearError(error);
    return true;
  }
  displayError(error, productQuantityError);
  return false;
}

// DECK function
// Checks if the price is over the maximum boundary of $10,000
// Returns true is the price is below or equal, false is over $10,000
function validatePrice(price) {
  let error = document.getElementById('quantity_error');
  if (price > 10000) {
    displayError(error, productOverpriceError);
    return false;
  }
  clearError(error);
  return true;
}

// ==================== Specific logic for deck products ====================
if (isDeck) {
    // Selectors for each summary and unit type swatches
    var metric_summary = document.getElementById('summary-metric');
    var imperial_summary = document.getElementById('summary-imperial');
    var metric = document.getElementById('swatch-2-metric');
    var imperial = document.getElementById('swatch-2-imperial');

    // Hide imperial when metric is selected
    metric.addEventListener("click", function() {
      metric_summary.removeAttribute('hidden');
      imperial_summary.setAttribute('hidden', true);
    });

    // Hide metric when imperial is selected
    imperial.addEventListener("click", function() {
      imperial_summary.removeAttribute('hidden');
      metric_summary.setAttribute('hidden', true);
    });

    // Variables for metric
    var input_mm = document.getElementById("length_input_metric"); // input field
    var sqm = 0.00; // total area - sqm
    var wkg = 0.00; // total weight - kg
    var prm = 0.00; // total price - metric
    var prm_u = 0.00; // unit price for a specific size in metric

    // Variables for imperial
    var input_fe = document.getElementById('length_input_fe');
    var input_in = document.getElementById('length_input_in');
    var sqft = 0.00;
    var wlb = 0.00;
    var pri = 0.00; // total price - imperial
    var pri_u = 0.00;

    // Product base weight and price per square feet (as shown on the price list)
    var w = 0.00; // weight per sqft
    var p = 0.00; // price per sqft
    let discount = 0.25; // discount for deck
    var discounted = 0.00; // total saved with the discount
    let discounted_m = 0.00;
    let discounted_i = 0.00;

    // Product metadata, used to assign the correct weight and price per sqft
    var title = '';
    var description = '';
    var sidelaps = '';
    var id = ''; // variant id

    // >=======================================()-=-=o0o=-=-()=======================================<
    // On PAGE LOAD
    // >=======================================()-=-=o0o=-=-()=======================================<
    function displayPriceBySqft() {
      let price_tag = document.getElementById('price_sqft');
      getVariant();
      price_tag.textContent = '';
      price_tag.insertAdjacentHTML("afterbegin", getPriceDeck());
      if (Shopify.locale === 'fr') {
        price_tag.insertAdjacentHTML("beforeend", '$');
        price_tag.insertAdjacentHTML("beforeend", ' / pi²');
      } else {
        price_tag.insertAdjacentHTML("afterbegin", '$');
        price_tag.insertAdjacentHTML("beforeend", ' / ft²');
      }
    }


  function getShippingProvinces(plants) {
    let productProvinces = [];
    for (const plant in plants) {
      Array.prototype.push.apply(productProvinces, provinceByPlant.get(plants[plant]));
    }
    return new Set(productProvinces);
  }

  function hasShipping() {
    let userProvince = getCookieShippingProvince();
    let plants = deckMap.get(title).get('plants');
    let productProvinces = getShippingProvinces(plants);
    return productProvinces.has(userProvince);
  }

  function setShippingWarningBannerMsg() {
    let provinceShort = getCookieShippingProvince();
    let provinceLong = '';
    if (provinceAbbreviationsFR.has(provinceShort)) {
      if (isLocaleFR()) {
        provinceLong = provinceAbbreviationsFR.get(provinceShort);
        document.getElementById('fr-banner__user-province').textContent = provinceLong;
        document.getElementById('fr_phone').textContent = phoneByProvinceFR.get(provinceShort);
      } else {
        provinceLong = provinceAbbreviationsEN.get(provinceShort);
        document.getElementById('en-banner__user-province').textContent = provinceLong;
        document.getElementById('en_phone').textContent = phoneByProvinceEN.get(provinceShort);
      }
    }
  }
  
  var isModified = false;
  var modifiedIndex = '';
  
    window.addEventListener('load', (event) => {
      displayPriceBySqft();
      if (!getCookieShippingProvince() || hasShipping() || getCookieShippingProvince() === 'None') {
        document.getElementById('shipping-warning-banner').setAttribute('hidden', true);
      } else {
        setShippingWarningBannerMsg();
        document.getElementById('shipping-warning-banner').removeAttribute('hidden');
      }
      const propertiesMap = decodeURL();
      if (propertiesMap.size > 0) {
        isModified = true;
        fillDeckFields(propertiesMap);
        let buttonText = document.getElementById('addToCart_button_text');
        buttonText.textContent = locale === 'fr' ? "Modifier l'item" : "Update product";
      }
    });
    // >=======================================()-=-=o0o=-=-()=======================================<
    // On PAGE LOAD END
    // >=======================================()-=-=o0o=-=-()=======================================<

  function fillDeckFields(propertiesMap) {
    if (propertiesMap.get("sidelaps") === "Button punch") {
      document.getElementById('swatch-1-button-punch').setAttribute('checked', true);
      document.getElementById('swatch-1-screwed-cladding').removeAttribute('checked');
    }
    if (is_metric) {
      document.getElementById('swatch-2-metric').setAttribute('checked', true);
      document.getElementById('swatch-2-imperial').removeAttribute('checked'); // Update swatches
      metric_summary.removeAttribute('hidden');
      imperial_summary.setAttribute('hidden', true);
      metricOnClick();
      document.getElementById('length_input_metric').value = propertiesMap.get('metric_size');
    } else {
      document.getElementById('swatch-2-imperial').setAttribute('checked', true);
      document.getElementById('swatch-2-metric').removeAttribute('checked'); // Update swatches
      imperial_summary.removeAttribute('hidden');
      metric_summary.setAttribute('hidden', true);
      imperialOnClick();
      document.getElementById('length_input_fe').value = propertiesMap.get('feet');
      document.getElementById('length_input_in').value = propertiesMap.get('inches');
    }
    document.getElementById('quantity_input').value = propertiesMap.get('quantity');
    updateAll();
  }

    // Hard-coded list of all deck variants and their base price/weight/id
    // Liquid objects are instanced on page load and cannot be changed
    // Therefore current_variant.id always returns the first variant id
    function getVariant() {
      title = document.getElementById('form_product_name').value;
      description = document.getElementById("SingleOptionSelector-0").value;    
      w = getWeightDeck();
      p = getPriceDeck(); 
	  id = getVariantIdDeck(); 
    }

    // Updates all metric and imperial components and values
    function updateAll() {
      updateMetric();
      updateImperial();
    }
  
    // Calculates metric values from input values
    function updateMetric() {
      getVariant();

      let width = deckMap.get(title).get("width");
      let mm = input_mm.value;
      if (mm == '') mm = 0;
      sqm = (q * ((mm / 1000) * 3.281) * width / 12) / 10.764;
      
      wkg = w * (q * ((mm / 1000) * 3.281) * width / 12) / 2.205;
      prm = (p * sqm * 10.764);
      prm_u = (prm / q);

      // Check for discount availability
      if (sqm > 140) {
        discounted_m = prm * discount;
        prm -= discounted_m;
        prm_u = prm / q;
        document.getElementById('discount_row_m').removeAttribute('hidden');
      } else {
        discounted_m = 0.00;
        document.getElementById('discount_row_m').setAttribute('hidden', true);
      }

      updateSummary();
    }

    // Calculates imperial values from input values
    function updateImperial() {
      getVariant();
      
      let width = deckMap.get(title).get("width");
      let ft = input_fe.value;
      if (ft == '') ft = 0;
      ft = ft + (input_in.value / 12 * 10);
      sqft = q * ft * width / 12 / 10;
      
      wlb = w * sqft;
      pri = (p * sqft);
      pri_u = (pri / q);

      // Check for discount availability
      if (sqft > 1500) {
        discounted_i = pri * discount;
        pri -= discounted_i;
        pri_u = pri / q;
        document.getElementById('discount_row_i').removeAttribute('hidden');
      } else {
        discounted_i = 0.00;
        document.getElementById('discount_row_i').setAttribute('hidden', true);
      }

      updateSummary();
    }

    // Updates the summary text to be displayed
    function updateSummary() {
      document.getElementById('area_m').textContent = sqm.toFixed(2);
      document.getElementById('weight_m').textContent = wkg.toFixed(2);
      document.getElementById('summary_price_m').textContent = prm.toFixed(2);

      document.getElementById('area_i').textContent = sqft.toFixed(2);
      document.getElementById('weight_i').textContent = wlb.toFixed(2);
      document.getElementById('summary_price_i').textContent = pri.toFixed(2);

      discounted = is_metric ? discounted_m : discounted_i;
      // Display discounted amount
      if (discounted != 0) {
        document.getElementById('discount_m').textContent = "-" + discounted.toFixed(2);
        document.getElementById('discount_i').textContent = "-" + discounted.toFixed(2);
      }

      displayPriceBySqft();
      
      initValidation(pri.toFixed(2) > prm.toFixed(2) ? pri.toFixed(2) : prm.toFixed(2));
    }

    // Calls the corresponding validation functions on the form.
    // If all are valid, re-enable the Add To Cart button. Otherwise, keep disabled.
    // params
    //   price: the price shown in the summary section
    function initValidation(price) {
      let valid = true;
      let button = document.getElementById('addToCart_button');
      if (is_metric) {
        valid = valid && validateMetric();
      } else {
        valid = valid && validateImperial();
      }
      valid = validateQty() && validatePrice(price) && valid;
      isMobile = window.innerWidth <= 600;
      
      if (valid && !isMobile) {
        button.removeAttribute('aria-disabled');
        button.removeAttribute('disabled');
      } else {
        button.setAttribute('aria-disabled', true);
        if (!validatePrice(price)) {
          button.setAttribute('disabled', true);
          document.getElementById('quantity_error_wrapper').removeAttribute('hidden');
        }
      }
    }

    // Variables for quantity entered
    var input_q = document.getElementById('quantity_input');
    var q = input_q.value;

    // Updates q and refreshes the whole summary
    input_q.addEventListener('input', function() {
      q = input_q.value;
      updateMetric();
      updateImperial();
    });

    // Trigger for displaying error message wrappers
    document.getElementById('addToCart_button').addEventListener('click', function () {
      document.getElementById('length_error_wrapper').removeAttribute('hidden');
      document.getElementById('quantity_error_wrapper').removeAttribute('hidden');
      initValidation();
    });
}